import React from "react";
import { Sparkles, Trash2 } from "lucide-react";
import { CollapsibleSection } from "./CollapsibleSection";
import { UserPreference } from "../../../../../services/ai/types/ScanHistory.types";
import { generatePreferenceExplanation } from "../../../../../services/ai/PreferenceDetector";

interface PreferenceBannerProps {
  appliedCount: number;
  preferences: UserPreference[];
  onClearPreferences: () => void;
}

export const PreferenceBanner = ({
  appliedCount,
  preferences,
  onClearPreferences
}: PreferenceBannerProps): React.ReactElement | null => {
  if (appliedCount === 0 || preferences.length === 0) {
    return null;
  }

  return (
    <CollapsibleSection
      icon={
        <Sparkles
          className="size-4 flex-shrink-0 text-[hsl(var(--info))]"
          aria-hidden="true"
        />
      }
      title={`AI Co-Pilot applied ${appliedCount} preference${appliedCount !== 1 ? "s" : ""} to this scan.`}
      ariaLabel="AI preference banner"
      sectionClassName="my-3 rounded-lg border border-[var(--borderColor)] p-3"
    >
      {preferences.map((pref, index) => (
        <div
          key={`${pref.type}-${pref.areaName ?? ""}-${index}`}
          className="rounded-md bg-card p-2.5"
        >
          <p className="text-xs font-semibold text-foreground">
            {pref.description}
          </p>
          <p className="mt-0.5 text-xs text-muted-foreground">
            {generatePreferenceExplanation(pref)}
          </p>
        </div>
      ))}
      <button
        type="button"
        className="mt-2 flex items-center gap-1.5 rounded px-2 py-1.5 text-xs text-[hsl(var(--destructive))] hover:bg-[hsl(var(--destructive)/0.1)] focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1"
        onClick={onClearPreferences}
        aria-label="Clear all preferences"
      >
        <Trash2 className="size-3.5" aria-hidden="true" />
        Clear preferences
      </button>
    </CollapsibleSection>
  );
};
